export type AppType = 'EDITOR' | 'RECRUITER';
export const APPS: Record<AppType, AppType> = {
  EDITOR: 'EDITOR',
  RECRUITER: 'RECRUITER',
};
